import React from 'react';

import { Document, Page, Text, View } from '@react-pdf/renderer';

import TablePDF from './TablePDF';
import KeyValuePDF from '../shared/KeyValuePDF';
import GlosaryColorsPDF from '../shared/GlosaryColorsPDF';
import GlosaryAbreviationsPDF from '../shared/GlosaryAbreviationsPDF';
import DividerPDF from '../shared/DividerPDF';
import { mapHolidaysReportData } from './mapReportData';
import { getTablePDFStyle } from '../../constants';
import EmptyUserDataPDF from '../shared/EmptyUserDataPDF';
import { isTimeTrackerFlatReportEmpty } from '../../../utils/isTimeTrackerReportEmpty';

const ReportPDFHolidays = ({
  data = {},
  orientation = 'portrait',
  title,
  includeGlosary = true,
  emptyUserDataLines = [],
}) => {
  const styles = getTablePDFStyle();
  const isEmpty = isTimeTrackerFlatReportEmpty(data);

  return (
    <Document>
      <Page size="A4" orientation={orientation} style={styles.page}>
        <View height={410}>
          <View>
            <Text style={styles.title}>{title}</Text>
          </View>
          {includeGlosary && (
            <View>
              <View>
                <GlosaryAbreviationsPDF />
              </View>
              <View>
                <GlosaryColorsPDF />
              </View>
            </View>
          )}
          {isEmpty ? (
            <EmptyUserDataPDF lines={emptyUserDataLines} styles={styles} />
          ) : (
          mapHolidaysReportData(data, ({ id, employee, employer, columns, source, summary, footer }) => (
            <View wrap={false} key={id} style={styles.cardReport}>
              <TablePDF
                headerSection={
                  <View>
                    <View style={styles.infoHeader}>
                      {employee.map(({ label, value }) => (
                        <KeyValuePDF key={label} label={label} value={value} />
                      ))}
                    </View>

                    {employer.length > 0 && <DividerPDF />}

                    <View style={styles.infoHeader}>
                      {employer.map(({ label, value }) => (
                        <KeyValuePDF key={label} label={label} value={value} />
                      ))}
                    </View>
                  </View>
                }
                key={id}
                data={source}
                headers={columns}
                summary={summary}
                footer={footer}
              />
            </View>
          ))
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDFHolidays;
